/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AddRouteImport } from './routes/add'
import { Route as IdRouteImport } from './routes/$id'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VehicleIndexRouteImport } from './routes/vehicle/index'
import { Route as CustomerIndexRouteImport } from './routes/customer/index'
import { Route as VehicleAddRouteImport } from './routes/vehicle/add'
import { Route as VehicleIdRouteImport } from './routes/vehicle/$id'
import { Route as CustomerAddRouteImport } from './routes/customer/add'
import { Route as CustomerIdRouteImport } from './routes/customer/$id'

const AddRoute = AddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => rootRouteImport,
} as any)
const IdRoute = IdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehicleIndexRoute = VehicleIndexRouteImport.update({
  id: '/vehicle/',
  path: '/vehicle/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerIndexRoute = CustomerIndexRouteImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehicleAddRoute = VehicleAddRouteImport.update({
  id: '/vehicle/add',
  path: '/vehicle/add',
  getParentRoute: () => rootRouteImport,
} as any)
const VehicleIdRoute = VehicleIdRouteImport.update({
  id: '/vehicle/$id',
  path: '/vehicle/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAddRoute = CustomerAddRouteImport.update({
  id: '/customer/add',
  path: '/customer/add',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerIdRoute = CustomerIdRouteImport.update({
  id: '/customer/$id',
  path: '/customer/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$id': typeof IdRoute
  '/add': typeof AddRoute
  '/customer/$id': typeof CustomerIdRoute
  '/customer/add': typeof CustomerAddRoute
  '/vehicle/$id': typeof VehicleIdRoute
  '/vehicle/add': typeof VehicleAddRoute
  '/customer/': typeof CustomerIndexRoute
  '/vehicle/': typeof VehicleIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$id': typeof IdRoute
  '/add': typeof AddRoute
  '/customer/$id': typeof CustomerIdRoute
  '/customer/add': typeof CustomerAddRoute
  '/vehicle/$id': typeof VehicleIdRoute
  '/vehicle/add': typeof VehicleAddRoute
  '/customer': typeof CustomerIndexRoute
  '/vehicle': typeof VehicleIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$id': typeof IdRoute
  '/add': typeof AddRoute
  '/customer/$id': typeof CustomerIdRoute
  '/customer/add': typeof CustomerAddRoute
  '/vehicle/$id': typeof VehicleIdRoute
  '/vehicle/add': typeof VehicleAddRoute
  '/customer/': typeof CustomerIndexRoute
  '/vehicle/': typeof VehicleIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$id'
    | '/add'
    | '/customer/$id'
    | '/customer/add'
    | '/vehicle/$id'
    | '/vehicle/add'
    | '/customer/'
    | '/vehicle/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$id'
    | '/add'
    | '/customer/$id'
    | '/customer/add'
    | '/vehicle/$id'
    | '/vehicle/add'
    | '/customer'
    | '/vehicle'
  id:
    | '__root__'
    | '/'
    | '/$id'
    | '/add'
    | '/customer/$id'
    | '/customer/add'
    | '/vehicle/$id'
    | '/vehicle/add'
    | '/customer/'
    | '/vehicle/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  IdRoute: typeof IdRoute
  AddRoute: typeof AddRoute
  CustomerIdRoute: typeof CustomerIdRoute
  CustomerAddRoute: typeof CustomerAddRoute
  VehicleIdRoute: typeof VehicleIdRoute
  VehicleAddRoute: typeof VehicleAddRoute
  CustomerIndexRoute: typeof CustomerIndexRoute
  VehicleIndexRoute: typeof VehicleIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/add': {
      id: '/add'
      path: '/add'
      fullPath: '/add'
      preLoaderRoute: typeof AddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$id': {
      id: '/$id'
      path: '/$id'
      fullPath: '/$id'
      preLoaderRoute: typeof IdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicle/': {
      id: '/vehicle/'
      path: '/vehicle'
      fullPath: '/vehicle/'
      preLoaderRoute: typeof VehicleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/': {
      id: '/customer/'
      path: '/customer'
      fullPath: '/customer/'
      preLoaderRoute: typeof CustomerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicle/add': {
      id: '/vehicle/add'
      path: '/vehicle/add'
      fullPath: '/vehicle/add'
      preLoaderRoute: typeof VehicleAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicle/$id': {
      id: '/vehicle/$id'
      path: '/vehicle/$id'
      fullPath: '/vehicle/$id'
      preLoaderRoute: typeof VehicleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/add': {
      id: '/customer/add'
      path: '/customer/add'
      fullPath: '/customer/add'
      preLoaderRoute: typeof CustomerAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/$id': {
      id: '/customer/$id'
      path: '/customer/$id'
      fullPath: '/customer/$id'
      preLoaderRoute: typeof CustomerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  IdRoute: IdRoute,
  AddRoute: AddRoute,
  CustomerIdRoute: CustomerIdRoute,
  CustomerAddRoute: CustomerAddRoute,
  VehicleIdRoute: VehicleIdRoute,
  VehicleAddRoute: VehicleAddRoute,
  CustomerIndexRoute: CustomerIndexRoute,
  VehicleIndexRoute: VehicleIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
